import { Component, Input } from '@angular/core';
import { Categories } from 'src/app/models/types/Rule/Rule.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { RulesService } from 'src/app/services/api/rules.service';

@Component({
  selector: 'app-category-header',
  imports: [
    SharedModule
  ],
  templateUrl: './category-header.component.html',
  styleUrl: './category-header.component.scss'
})
export class CategoryHeaderComponent {

  @Input('ruleName') ruleName!: string;
  @Input('categories') categories?: Categories;

  constructor(public readonly rulesService: RulesService) { }

}
